if (!customElements.get('campaign-media-collage')) {
  customElements.define(
    'campaign-media-collage',
    class CampaignMediaCollage extends HTMLElement {
      connectedCallback() {
        this.autoplay = this.dataset.autoplay === 'true';
        this.controls = this.dataset.controls === 'true';
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.isVisible = false;
        this.syncPlayback = this.syncPlayback.bind(this);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            ([entry]) => {
              this.isVisible = entry.isIntersecting;
              this.syncPlayback();
            },
            { rootMargin: '160px 0px', threshold: 0.01 }
          );
          this.observer.observe(this);
        } else {
          this.isVisible = true;
        }

        this.mediaQuery.addEventListener('change', this.syncPlayback);
        this.motionQuery.addEventListener('change', this.syncPlayback);
        document.addEventListener('visibilitychange', this.syncPlayback);
        this.syncPlayback();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mediaQuery?.removeEventListener('change', this.syncPlayback);
        this.motionQuery?.removeEventListener('change', this.syncPlayback);
        document.removeEventListener('visibilitychange', this.syncPlayback);
        this.pauseAll();
      }

      get activeSlotClass() {
        return this.mediaQuery.matches
          ? '.campaign-media-collage__featured-slot--mobile'
          : '.campaign-media-collage__featured-slot--desktop';
      }

      syncActiveSlot() {
        const isMobile = this.mediaQuery.matches;
        const desktopSlot = this.querySelector('.campaign-media-collage__featured-slot--desktop');
        const mobileSlot = this.querySelector('.campaign-media-collage__featured-slot--mobile');

        if (desktopSlot) desktopSlot.hidden = isMobile;
        if (mobileSlot) mobileSlot.hidden = !isMobile;
      }

      pauseAll() {
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      syncPlayback() {
        this.syncActiveSlot();

        const reducedMotion = this.motionQuery.matches;
        const shouldPlay = this.autoplay && this.isVisible && !document.hidden && !reducedMotion;
        const activeVideos = new Set(this.querySelectorAll(`${this.activeSlotClass} video`));

        this.querySelectorAll('video').forEach((video) => {
          const isActive = activeVideos.has(video);
          video.controls = isActive && (this.controls || reducedMotion || !this.autoplay);

          if (!shouldPlay || !isActive) {
            video.pause();
            return;
          }

          video.muted = true;
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });
      }
    }
  );
}
